
import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { InputWithEmojiPicker } from "@/components/ui/InputWithEmojiPicker";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { X } from "lucide-react";

interface TaskCreateModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (title: string, detail: string) => void;
}
export const TaskCreateModal: React.FC<TaskCreateModalProps> = ({
  open,
  onClose,
  onSave
}) => {
  const [title, setTitle] = useState("");
  const [detail, setDetail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSave = async () => {
    if (!title.trim()) return;
    setSubmitting(true);
    await onSave(title, detail);
    setTitle("");
    setDetail("");
    setSubmitting(false);
    onClose();
  };

  const handleCancel = () => {
    setTitle("");
    setDetail("");
    setSubmitting(false);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto bg-white dark:bg-white text-black">
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          onClick={onClose}
          aria-label="Close"
          type="button"
        >
          <X />
        </button>
        <DialogTitle className="mb-6 text-2xl font-bold text-black w-full text-center">New Task</DialogTitle>
        <form 
          className="flex flex-col space-y-6 w-full max-w-xl"
          onSubmit={e => { e.preventDefault(); handleSave(); }}
        >
          <div className="space-y-2">
            <Label htmlFor="task-title" className="text-sm font-medium">
              Task Title
            </Label>
            <InputWithEmojiPicker
              id="task-title"
              value={title}
              onChange={e => setTitle(e.target.value)}
              placeholder="Enter task title..."
              className="w-full text-lg py-3 px-4"
              disabled={submitting}
              autoFocus
              maxLength={120}
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="task-detail" className="text-sm font-medium">
              Details
            </Label>
            <Textarea
              id="task-detail"
              value={detail}
              onChange={e => setDetail(e.target.value)}
              placeholder="Add task details..."
              rows={4}
              className="w-full min-h-[100px] text-base px-4 py-3"
              disabled={submitting}
              maxLength={250}
            />
          </div>
          <div className="flex justify-end gap-3">
            <Button 
              type="button"
              variant="outline"
              onClick={handleCancel}
              disabled={submitting}
            >
              Cancel
            </Button>
            <Button 
              onClick={handleSave} 
              disabled={!title.trim() || submitting}
              variant="default"
              type="submit"
            >
              Create
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
